// src/services/api.js

// Определяем базовый URL API.
// В реальном приложении это может быть в .env файле или конфигурации сборки.
// window.APP_CONFIG?.apiUrl используется, если конфигурация внедряется глобально.
// const DYNAMIC_API_URL = window.APP_CONFIG?.apiUrl;
const DYNAMIC_API_URL = process.env.REACT_APP_API_URL;
const FALLBACK_API_URL = 'http://localhost:3001/api'; // Запасной URL для локальной разработки
const apiUrl = DYNAMIC_API_URL || FALLBACK_API_URL;

console.log(`API URL configured: ${apiUrl}`);


// Основная функция для выполнения запросов
const apiService = async (endpoint, method = 'GET', data = null, headers = {}) => {
    const config = {
        method: method,
        headers: {
            // 'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...headers
            // Сюда можно добавить заголовки авторизации (например, Bearer token)
            // 'Authorization': `Bearer ${getToken()}`
        },
    };
    config.headers['Telegram-Data'] = window?.Telegram?.WebApp?.initData;

    if (data && (method === 'POST' || method === 'PUT')) {
        // config.body = JSON.stringify(data);

        if (data instanceof FormData) {
            // --- НАЧАЛО ИСПРАВЛЕНИЯ ---
            // Если мы отправляем FormData, мы НЕ должны устанавливать Content-Type.
            // Браузер сделает это сам с правильным boundary.
            // Удаляем его, даже если он был случайно передан.
            delete config.headers['Content-Type'];
            config.body = data;
            // --- КОНЕЦ ИСПРАВЛЕНИЯ ---
        } else {
            // Устанавливаем заголовок только для JSON и других типов данных
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(data);
        }

    } else if (data && method === 'GET') {
        const queryString = new URLSearchParams(data).toString();
        endpoint += `?${queryString}`;
    }

    const url = `${apiUrl}/${endpoint}`;

    try {
        const response = await fetch(url, config);

        const responseData = await response.json();

        if (!response.ok) {
            console.error(`API Error ${response.status}:`, responseData);
            // Выбрасываем ошибку, чтобы ее можно было поймать в вызывающем коде
            // throw new Error(responseData.message || `Request failed with status ${response.status}`);

            const error = new Error(responseData.message || `Request failed with status ${response.status}`);
            error.response = {
                data: responseData,
                status: response.status,
                statusText: response.statusText,
            };
            throw error;
        }

        console.log(`[API Success] ${method} /${endpoint}:`, responseData);
        return responseData; // Возвращаем распарсенные данные (например, { rez: true, data: {...} })

    } catch (error) {
        console.error(`API Exception for ${method} /${endpoint}:`, error);
        // Перевыбрасываем ошибку или возвращаем стандартизированный объект ошибки
        throw error; // Позволяем вызывающему коду обработать ошибку
    }
};

// Вспомогательные функции для GET, POST и т.д.
export const get = (endpoint, data) => apiService(endpoint, 'GET', data);
export const post = (endpoint, data) => apiService(endpoint, 'POST', data);
export const put = (endpoint, data) => apiService(endpoint, 'PUT', data);
export const del = (endpoint) => apiService(endpoint, 'DELETE');

// Экспорт по умолчанию может быть удобен
export default apiService;
